<div class="header-panel">
  <mtg-statistic-filters-widget
    *ngIf="isBrowser"
    [league]="league"
    [seasonId]="seasonId"
    [tournamentId]="tournamentId"
    [roundId]="round"
    [additionalFiltersVisible]="true"
    (filters)="setFilters($event)"
  ></mtg-statistic-filters-widget>
</div>
<div class="content" *ngIf="statistic">
  <div class="title">Лидеры сезона ТОП-10 игроков</div>
  <div class="hint">Статистика по всей лиге</div>

  <div class="divider"></div>

  <mtg-basketball-statistic-leaders
    *ngIf="league.sport.isBasketball()"
    [statistic]="statistic"
  ></mtg-basketball-statistic-leaders>
  <mtg-hockey-statistic-leaders
    *ngIf="league.sport.isHockey()"
    [statistic]="statistic"
  ></mtg-hockey-statistic-leaders>
  <mtg-volleyball-statistic-leaders
    *ngIf="league.sport.isVolleyball()"
    [statistic]="statistic"
  ></mtg-volleyball-statistic-leaders>
  <mtg-football-statistic-leaders
    *ngIf="league.sport.isFootball()"
    [statistic]="statistic"
  ></mtg-football-statistic-leaders>
  <mtg-handball-statistic-leaders
    *ngIf="league.sport.isHandball()"
    [statistic]="statistic"
  ></mtg-handball-statistic-leaders>
  <mtg-rugby-statistic-leaders
    *ngIf="league.sport.isRugby()"
    [statistic]="statistic"
  ></mtg-rugby-statistic-leaders>

  <div class="tournament-statistics">
    <mtg-statistic-table-grouped
      *ngIf="isGroupedStatistic()"
      [statistic]="statistic"
      [sport]="league.sport"
      [pageSize]="10"
      identity="teamUser"
    ></mtg-statistic-table-grouped>
    <mtg-statistic-table
      *ngIf="!isGroupedStatistic()"
      [statistic]="statistic"
      [sport]="league.sport"
      [statisticHeader]="getStatisticHeader(league.sport, false)"
      [pageSize]="10"
      [sort]="getDefaultSort()"
      identity="teamUser"
    ></mtg-statistic-table>
  </div>
</div>
<div class="loading" *ngIf="!statistic">
  <mtg-spinner></mtg-spinner>
</div>
